module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-R-12.6fdfbcb7.png";